var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailCardIcon12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7263 22.748L3.57309 9.97314C2.95153 10.5524 2.56055 11.3757 2.56055 12.2923V32.2139C2.56055 33.1762 2.99056 34.0366 3.66701 34.6185L19.7761 23.4329C19.4071 23.2491 19.0533 23.0237 18.7263 22.748Z",
    fill: "#F17373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6844 32.2139V12.2923C41.6844 11.3757 41.2933 10.5524 40.6718 9.97314L25.5186 22.748C25.1915 23.0237 24.8377 23.2491 24.4688 23.4329L40.5779 34.6185C41.2543 34.0366 41.6844 33.1762 41.6844 32.2139Z",
    fill: "#F17373"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4718 23.4329L22.1254 21.8037L19.7791 23.4329L3.66992 34.6185C4.2253 35.0962 4.94626 35.3868 5.7363 35.3868H38.5146C39.3047 35.3868 40.0256 35.0962 40.581 34.6185L24.4718 23.4329Z",
    fill: "#FB8888"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.512 22.7481L40.6652 9.97326C40.0986 9.44519 39.3407 9.11963 38.505 9.11963H5.72667C4.89098 9.11963 4.13309 9.44519 3.56641 9.97326L18.7196 22.7481C20.6817 24.4022 23.55 24.4022 25.512 22.7481Z",
    fill: "#FFBEBE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2095 37.1453C33.2095 37.1453 39.8994 33.8003 39.8994 28.7828V22.9291L33.2095 20.4204L26.5195 22.9291V28.7828C26.5195 33.8003 33.2095 37.1453 33.2095 37.1453Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2095 37.1453C33.2095 37.1453 39.8994 33.8003 39.8994 28.7828V22.9291L33.2095 20.4204L26.5195 22.9291V28.7828C26.5195 33.8003 33.2095 37.1453 33.2095 37.1453Z",
    fill: "url(#paint0_linear_1433_48282)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5078 27.5531L32.4593 30.5045L37.3783 25.5854",
    stroke: "white",
    strokeWidth: 1.47572,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1433_48282",
    x1: 33.2095,
    y1: 20.4204,
    x2: 33.2095,
    y2: 37.1453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DC0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailCardIcon12);
export default __webpack_public_path__ + "static/media/mail_card_icon12.e8119afda6844f7df24ff37da77a59cc.svg";
export { ForwardRef as ReactComponent };